var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    staticClass: "app-spinner",
    style: { width: `${_vm.size}px`, height: `${_vm.size}px` },
    attrs: { role: "status", "aria-label": _vm.label },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }